import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  max-width: 600px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    flex-direction: column;
    max-width: 800px;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.lg}) {
    min-width: 516px;
    padding: 20px 0 20px 60px;
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const TabTitle = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black9};
`;

export const ActionsWrapper = styled.div`
  display: flex;
  gap: 16px;
`;
